import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import MessageBanner from '../messageBanner/MessageBanner';
import { errorSVG } from '../../lib/allCustomSVGs';
import { tokenRevokeAtLogOutUser } from '../../lib/api/logout-user';
import {
  APP_ENV,
  INTERCOM_ENABLED_ENVS,
} from '../../lib/constants/central-api';
import localStorageHardReset from '../../lib/helper-functions/localStorageHardReset';
import { usePlanLock } from '../../lib/plan-lock/usePlanLock';

/**
 * What a member sees when the organisation has no active plan and they cannot
 * buy one themselves: the reason, who can fix it, and a way out.
 *
 * The owner is not named: the team list is not readable for a locked
 * organisation and the session holds no owner details.
 *
 * A member with billing rights but no seller session (an invited co-owner) is
 * told which sign-in can buy a plan, since there is no one for them to ask.
 */
const PlanLockScreen = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { needsAccountHolderSignIn } = usePlanLock();
  const signOut = () => {
    tokenRevokeAtLogOutUser();
    if (INTERCOM_ENABLED_ENVS.includes(APP_ENV)) {
      // @ts-ignore:next-line
      window.Intercom && window.Intercom('shutdown');
    }
    localStorageHardReset();
    navigate('/login');
  };

  return (
    <div data-testid='plan-lock-screen'>
      <MessageBanner
        icon={errorSVG}
        title={t('PlanLock-MemberTitle')}
        subTitle={
          needsAccountHolderSignIn
            ? t('PlanLock-AccountHolder')
            : t('PlanLock-AskOwner')
        }
        btnTitle={t('Logout')}
        onSelect={signOut}
        success={false}
      />
    </div>
  );
};

export default PlanLockScreen;
